import React, {
  ChangeEvent,
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  AvailableWorkflowModel,
  GroupListModel,
  SkillsGroupListModel,
  SkillsUserListModel,
  SkillsWorkflowAvailableProps,
} from "../../models/SkillsData";
import "./AvailableWorkflowSkills.scss";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  ListItemText,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../../../../shared/services/api/API";
import { OPTIVAL_CONSTANTS } from "../../../../shared/Constants";
import { WorkflowConstants } from "../../../workflow/models/Workflow";
import { Order, TableHeadCell } from "../../../../shared/models/TableModels";
import { tableSorting } from "../../../../shared/utils/Utils";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { visuallyHidden } from "@mui/utils";
import { useSkillsUtils } from "../../components/skills/SkillsUtil";
import { MapWorkflowDialog } from "../map-workflow/MapWorkflowDialog";
import { SkillsContext } from "../../contexts/SkillsContext";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const AvailableWorkflowSkills = (
  props: SkillsWorkflowAvailableProps
) => {
  const {
    levelId,
    levelName,
    row,
    collapseClose,
    selectGroupsList,
    workflowDataList,
    assignedIds,
    fetchWorkflowList,
    groupList,
    filterGroupData,
    getEligibleUsers
  } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { httpPost, handleAlertBar } = useAPI();
  const [workflowDataVisible, setWorkflowDataVisible] = useState<
    AvailableWorkflowModel[]
  >([]);
  const [groupDataVisible, setGroupDataVisible] = useState<
    SkillsUserListModel[]
  >([]);
  const { getAvailableWFHeaderCell, getAvailableUserGroupHeaderCell } =
    useSkillsUtils();
  const [perPageRows, setPerPageRows] = useState<number>(5);
  const [perPageRowsGroup, setPerPageRowsGroup] = useState<number>(5);
  const [selected, setSelected] = useState<readonly number[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<readonly number[]>([]);
  const [page, setPage] = useState(0);
  const [pageGroup, setPageGroup] = useState(0);
  const [order, setOrder] = useState<Order>("desc");
  const [orderBy, setOrderBy] = useState<string>("name");
  const [tableHeaderCell, setTableHeaderCell] = useState<TableHeadCell[]>([]);
  const [groupTableHeaderCell, setGroupTableHeaderCell] = useState<
    TableHeadCell[]
  >([]);
  const [groupsList, setGroupsList] = useState<SkillsGroupListModel[]>([]);
  const [filterGroupList, setFilterGroupList] = useState<SkillsGroupListModel[]>([]);
  const [openGroupDialog, setOpenGroupDialog] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { updateValidateLessMore } = useContext(SkillsContext);
  const [ selectedGroupIds, setSelectedGroupIds] = useState<string[]>([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const isAllSelectedGroup = groupList && selectedGroupIds.length === groupList.length;
  // const handleChange = (event: SelectChangeEvent<string[]>) => {
  //   const value = event.target.value;
  //   // If "all" is selected, toggle all
  //   if (value.includes('all')) {
  //     if (isAllSelectedGroup) {
  //       setSelectedGroupIds([]);
  //     } else {
  //       setSelectedGroupIds(groupList ? groupList.map((group) => group.id) : []);
  //     }
  //   } else {
  //     setSelectedGroupIds(typeof value === 'string' ? value.split(',') : value);
  //   }
  // };

  const viewAllWorkflows = () => {
    navigate("../instrukt", {
      state: {
        row: {
          id: row?.skillId,
          label: row.skillName,
          levelName: levelName,
          levelId: levelId,
        },
      },
    });
  };

  const navigateSkillAssignment = () => {
    updateValidateLessMore(true);
    navigate("../assign-skill", {
      state: { skillId: row?.skillId, skillName: row.skillName, tabValue: "GROUPS" }
      },
    );
  };

  const assignWorkflows = async () => {
    const reqBody = {
      workflowIds: selected,
      employeeIds: selectedGroup,
    };
    await httpPost(
      `${OPTIVAL_CONSTANTS.API_URLS.SKILLS_ASSIGNED_WORKFLOW}`,
      reqBody
    ).then(
      (response) => {
        if (response && response.data && response.data.error) {
          handleAlertBar("error", response.data.message);
        } else {
          handleAlertBar(
            "success",
            t("opva.workflowAssignedGroupSuccessfully.")
          );
          collapseClose();
        }
      },
      (error) => { }
    );
  };

  const handleSelectCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      workflowDataList
        .filter(
          (workflow: AvailableWorkflowModel) =>
            workflow?.workflowWithVersionDto?.id === id
        )
        .map((workflow: AvailableWorkflowModel) => {
          workflow.isChecked = true;
          return workflow;
        });
      newSelected = [...selected, id];
    } else {
      workflowDataList
        .filter(
          (workflow: AvailableWorkflowModel) =>
            workflow?.workflowWithVersionDto?.id === id
        )
        .map((workflow: AvailableWorkflowModel) => {
          workflow.isChecked = false;
          return workflow;
        });
      newSelected = selected?.filter((selectedId) => selectedId !== id);
    }
    setSelected(newSelected);
  };

  const handleGroupSelectCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const selectedIndex = selectedGroup.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = [...selectedGroup, id];
    } else {
      newSelected = selectedGroup?.filter((selectedId) => selectedId !== id);
    }
    setSelectedGroup(newSelected);
  };

  const removeSelectedWorkflow = () => {
    const assignIds = assignedIds;
    setSelected(assignIds);
  };

  const removeSelectedGroup = () => {
    setSelectedGroup([]);
  };

  const isSelected = (id: number) => selected.indexOf(id) !== -1;
  const isSelectedGroup = (id: number) => selectedGroup.indexOf(id) !== -1;

  const renderTruncateTitle = (title: string, whereTo: string): string => {
    return title.length > WorkflowConstants.WORKFLOW_TITLE_LENGTH
      ? whereTo === "display"
        ? title.substring(0, WorkflowConstants.WORKFLOW_TITLE_LENGTH) + "..."
        : title
      : whereTo === "display"
        ? title
        : "";
  };

  const renderGroupname = (data: SkillsGroupListModel[]) => {
    const groupNames = data.map((g) => g.name).join(", ");
    const shouldTruncate = groupNames.length > 130;
    return (
      <>
        {shouldTruncate ? (
          <span>
            {groupNames.substring(0, 130)}{" "}
            <Link component="button" onClick={() => handleView(data)}>
              {t("opva.viewMore")}
            </Link>
          </span>
        ) : (
          groupNames
        )}
      </>
    );
  };

  const handleEmptyPage = (data: any) => {
    const sliceArr = data.slice(
      page * perPageRows,
      page * perPageRows + perPageRows
    );
    if (!sliceArr.length) {
      setPage(page === 0 ? 0 : page - 1);
    }
  };

  const handleEmptyPageGroup = (data: any) => {
    const sliceArr = data.slice(
      pageGroup * perPageRowsGroup,
      pageGroup * perPageRowsGroup + perPageRowsGroup
    );
    if (!sliceArr.length) {
      setPageGroup(page === 0 ? 0 : page - 1);
    }
  };

  useMemo(() => {
    handleEmptyPage(workflowDataList);
    handleEmptyPageGroup(selectGroupsList);
    const checkedRowIds = workflowDataList
      .filter((workflow: AvailableWorkflowModel) => workflow?.isChecked)
      .map(
        (workflow: AvailableWorkflowModel) =>
          workflow?.workflowWithVersionDto?.id
      );
    setSelected(checkedRowIds);
    const propertyType = ["groupsAssigned", "noOfVersions"].includes(orderBy)
      ? "number"
      : "string";
    const sortedList = tableSorting(
      workflowDataList,
      order,
      orderBy,
      propertyType
    );
    const sortedListGroup = tableSorting(
      selectGroupsList,
      order,
      orderBy,
      propertyType
    );
    setWorkflowDataVisible(
      sortedList.slice(page * perPageRows, page * perPageRows + perPageRows)
    );
    setGroupDataVisible(
      sortedListGroup.slice(
        pageGroup * perPageRowsGroup,
        page * perPageRowsGroup + perPageRowsGroup
      )
    );
  }, [
    order,
    orderBy,
    page,
    page,
    perPageRows,
    perPageRowsGroup,
    workflowDataList,
    selectGroupsList,
  ]);

  const handleSorting = (property: string) => {
    console.log("property---->", property);
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  useEffect(() => {
    setTableHeaderCell(getAvailableWFHeaderCell());
    setGroupTableHeaderCell(getAvailableUserGroupHeaderCell());
  }, [workflowDataVisible]);

  const checkedWorkflow = () => {
    if (selected.length === 0 && workflowDataList.length === 0) return false;
    for (let workflow of workflowDataList) {
      const isPresent = selected.some(
        (id: any) => id === workflow?.workflowWithVersionDto?.id
      );
      if (!isPresent) {
        return false;
      }
    }
    return true;
  };

  const handleAllCheckBoxForWorkflow = (event: any) => {
    if (event.target.checked) {
      const uniqueWorkFlowsIds: number[] = [];
      workflowDataList.forEach((workflow: AvailableWorkflowModel) => {
        const index = selected.findIndex(
          (id: number) => id === workflow?.workflowWithVersionDto?.id
        );
        workflow.isChecked = true;
        if (index === -1) {
          uniqueWorkFlowsIds.push(workflow?.workflowWithVersionDto?.id);
        }
      });
      setSelected([...selected, ...uniqueWorkFlowsIds]);
    } else {
      removeSelectedWorkflow();
    }
  };

  const checkedGroup = () => {
    if (selectedGroup.length === 0 && selectGroupsList.length === 0)
      return false;
    for (let group of selectGroupsList) {
      const isPresent = selectedGroup?.some((id: any) => id === group?.id);
      if (!isPresent) {
        return false;
      }
    }
    return true;
  };

  const handleAllCheckBoxForGroup = (event: any) => {
    if (event.target.checked) {
      const uniqueUserIds: number[] = [];
      selectGroupsList.forEach((group: SkillsUserListModel) => {
        const index = selectedGroup.findIndex((id: number) => id === group?.id);
        if (index === -1) {
          uniqueUserIds.push(group?.id);
        }
      });
      setSelectedGroup([...selectedGroup, ...uniqueUserIds]);
    } else {
      removeSelectedGroup();
    }
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
    const startIndex = newPage * perPageRows;
    setWorkflowDataVisible([
      ...workflowDataList.slice(startIndex, startIndex + perPageRows),
    ]);
  };
  const handleGroupChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageGroup(newPage);
    const startIndex = newPage * perPageRows;
    setGroupDataVisible([
      ...selectGroupsList.slice(startIndex, startIndex + perPageRows),
    ]);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPerPageRows(parseInt(event.target.value, 10));
    setPage(0);
    setGroupDataVisible(
      selectGroupsList.slice(0, parseInt(event.target.value, 10))
    );
  };

  const handleGroupChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPerPageRows(parseInt(event.target.value, 10));
    setPageGroup(0);
    setWorkflowDataVisible(
      workflowDataList.slice(0, parseInt(event.target.value, 10))
    );
  };

  const handleNotify = async (data: AvailableWorkflowModel) => {
    const reqBody = {
      workflowId: data?.workflowWithVersionDto?.id,
      skillId: row?.skillId,
      skillLevelId: levelId,
    };
    await httpPost(
      `${OPTIVAL_CONSTANTS.API_URLS.SKILLS_NOTIFICATION_NOTIFY}`,
      reqBody
    ).then(
      (response) => {
        if (response && response.data && response.data.error) {
          handleAlertBar("error", response.data.message);
        } else {
          handleAlertBar("success", t("opva.incompleteWorkflowNotify"));
        }
      },
      (error) => { }
    );
  };
  const closeDialog = () => {
    setIsOpen(false);
    fetchWorkflowList();
  };

  const handleView = (groups: any) => {
    setOpenGroupDialog(true);
    setGroupsList(groups);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (id: any) => {
    setSelectedGroupIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const handleApply = () => {
    console.log('Apply clicked:', selectedGroupIds);
    handleClose();
    filterGroupData(selectedGroupIds, row?.skillId)
  };
  const handleClear = () => {
    setSelectedGroupIds([]);
    console.log('Clear All clicked');
    handleClose();
    getEligibleUsers();
  };

  const getSelectedGroupNamesDisplay = () => {
    const selectedName = groupList ? groupList.filter((opt) => selectedGroupIds.includes(opt.id)).map((opt) => opt.name) : [];
    const displayCount = 2;
    if (selectedName.length <= displayCount) {
      return selectedName.join(', ');
    } else {
      const extra = selectedName?.length - displayCount;
      return `${selectedName?.slice(0, displayCount).join(', ')}+ ${extra} more`;
    }
  }
  return (
    <React.Fragment>
      <div className="available-workflow-skills-container">
        <Grid container>
          <Grid item xs={6} md={10}>
            <Typography variant="h6" className="mb-3">
              {t(`opva.${levelId}WorkflowsAvailable`)}
            </Typography>
          </Grid>
          <Grid item xs={4} md={1.5}>
            <Button
              variant="outlined"
              color="primary"
              sx={{ textTransform: "none", backgroundColor: "#FFFF" }}
              onClick={viewAllWorkflows}
              disabled={workflowDataVisible.length === 0}
            >
              {t("opva.viewAllWorkflows")}
            </Button>
          </Grid>
          <Grid item xs={2} md={0.5}>
            <Link
              component="button"
              className="float-end"
              title="Close"
              onClick={collapseClose}
            >
              <CloseIcon />
            </Link>
          </Grid>
        </Grid>
        <div className="d-flex align-items-center justify-content-start pb-8">
          <Typography variant="bodySmall">{`${selected.length}/${workflowDataList.length} selected`}</Typography>
        </div>
        {selected.length < 0 && (
          <Typography
            variant="bodySmall"
            color={"#0084F4"}
            style={{
              cursor: "pointer",
            }}
            onClick={() => removeSelectedWorkflow()}
          >
            {t("opva.deselectAll")}
          </Typography>
        )}
        {workflowDataVisible && workflowDataVisible.length ? (
          <TableContainer className="workflow-table-container">
            <Table
              stickyHeader
              sx={{ width: "100%", overflow: "auto", maxHeight: "20%" }}
              size="medium"
              aria-label="Available Workflow table"
            >
              <TableHead>
                <TableRow key="available-workflow-table-header">
                  <TableCell size="small" padding="checkbox" sx={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <Checkbox
                      sx={{
                        padding: 0,
                        display: 'block',
                        margin: '0 auto',
                      }}
                      checked={checkedWorkflow()}
                      onChange={(e) => handleAllCheckBoxForWorkflow(e)}
                    />
                  </TableCell>
                  {tableHeaderCell.map((headCell: TableHeadCell) => (
                    <TableCell
                      key={headCell.id}
                      sortDirection={
                        orderBy === headCell.sortingProperty ? order : false
                      }
                      align={headCell.position}
                    // sx={{
                    //   width: headCell.width + "%",
                    // }}
                    >
                      {headCell.sorting ? (
                        <TableSortLabel
                          active={orderBy === headCell.sortingProperty}
                          direction={
                            orderBy === headCell.sortingProperty ? order : "asc"
                          }
                          onClick={() =>
                            handleSorting(headCell.sortingProperty)
                          }
                        >
                          {headCell.label}
                          {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                              {orderBy === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {workflowDataVisible && workflowDataVisible.length ? (
                  workflowDataVisible.map(
                    (data: AvailableWorkflowModel, index) => {
                      const isItemSelected = isSelected(
                        data?.workflowWithVersionDto?.id
                      );
                      const labelId = `table-checkbox-${index}`;

                      return (
                        <Fragment key={index}>
                          <TableRow
                            role="checkbox"
                            tabIndex={-1}
                            aria-checked={isItemSelected}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox" sx={{ textAlign: 'center', verticalAlign: 'middle' }}>
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                onChange={(event) =>
                                  handleSelectCheckbox(
                                    event,
                                    data?.workflowWithVersionDto?.id
                                  )
                                }
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}

                                sx={{
                                  padding: 0,
                                  display: 'block',
                                  margin: '0 auto',
                                }}
                              />
                            </TableCell>
                            <TableCell>{row?.skillName}</TableCell>
                            <TableCell>{levelName}</TableCell>

                            <TableCell>
                              <span
                                title={renderTruncateTitle(
                                  data?.workflowWithVersionDto?.name,
                                  "title"
                                )}
                              >
                                {renderTruncateTitle(
                                  data?.workflowWithVersionDto?.name,
                                  "display"
                                )}
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              {data?.workflowWithVersionDto?.publishedVersion}
                            </TableCell>
                            <TableCell align="center">
                              {data?.completedCount}
                            </TableCell>
                            <TableCell align="center">
                              <Link
                                component="button"
                                title={t("opva.notify")}
                                style={{
                                  pointerEvents: !(data?.assigned)
                                    ? "none"
                                    : "auto",
                                  opacity: !(data?.assigned)
                                    ? "0.5"
                                    : "1",
                                  cursor: !(data?.assigned)
                                    ? "default"
                                    : "pointer",
                                }}
                                onClick={() => handleNotify(data)}
                                disabled={!(data?.assigned)}
                              >
                                <NotificationsNoneIcon />
                              </Link>{" "}
                            </TableCell>
                          </TableRow>
                        </Fragment>
                      );
                    }
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={8}>
                      {t("opva.noWorkflowDataAvailable")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <div className="d-flex align-items-center justify-content-end">
              <TablePagination
                className="pagination-container"
                component="div"
                rowsPerPageOptions={[5, 10, 25]}
                count={workflowDataList?.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={perPageRows}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </TableContainer>
        ) : (
          <div className="d-flex align-items-center justify-content-start">
            <Typography variant="bodySmall" className="my-4">
              {t("opva.noWorkflowMappedToskillMsg")}{" "}
              <Link component="button" onClick={() => setIsOpen(true)}>
                {t("opva.clickHere")}
              </Link>
            </Typography>
          </div>
        )}
        <div>
          <Typography variant="h6" className="my-4">
            {t("opva.UsersSelected")}
          </Typography>
        </div>
        <div>
      </div>
        <div className="background-white pt-2">
          <FormControl sx={{ m: 1, width: 300, paddingLeft: 1 }} size="small">
      <Button onClick={handleClick} variant="outlined" style={{ textTransform: 'none', color: 'black', justifyContent: 'space-between', paddingRight: '12px' }} endIcon={anchorEl ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}>
        <span style={{ display: 'inline-block', maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'middle' }}>
          {selectedGroupIds.length > 0
          ? getSelectedGroupNamesDisplay()
          : t('opva.selectByGroup')}
        </span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: { width: 300 },
        }}
      >
        <div style={{ maxHeight: 200, overflowY: 'auto' }}>
          <MenuItem onClick={() => {
            if (selectedGroupIds?.length === groupList?.length && groupList?.length !== 0) {
              setSelectedGroupIds([]);
            } else {
              setSelectedGroupIds(groupList ? groupList.map((group) => group.id) : []);
            }
          }}>
                <Checkbox checked={selectedGroupIds?.length === groupList?.length && groupList?.length !== 0} />
                <ListItemText primary="Select All" />
              </MenuItem>
          {groupList && groupList.map((option: any) => (
            <MenuItem key={option?.id} onClick={() => handleChange(option?.id)}>
              <Checkbox checked={selectedGroupIds.includes(option?.id)} />
              <ListItemText title={option?.name} primary={option?.name} primaryTypographyProps={{ noWrap: true, style: {maxWidth: '220px'}}} />
            </MenuItem>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
          <Button variant="outlined" onClick={handleClear} sx={{ textTransform: "none" }}>
            {t("opva.clearAll")}
          </Button>
          <Button variant="contained" onClick={handleApply} disabled={selectedGroupIds.length === 0} color="primary" sx={{ textTransform: "none" }}>
            {t("opva.apply")}
          </Button>
        </div>
      </Menu>
    </FormControl>

        </div>
        {groupDataVisible && groupDataVisible.length ? (
          <TableContainer className="workflow-table-container">
            <Table
              stickyHeader
              sx={{ width: "100%", overflow: "auto", maxHeight: "20%" }}
              size="medium"
              aria-label="Available Group table"
            >
              <TableHead>
                <TableRow key="available-workflow-table-header">
                  <TableCell size="small" padding="checkbox" sx={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <Checkbox
                      sx={{
                        padding: 0,
                        display: 'block',
                        margin: '0 auto',
                      }}
                      checked={checkedGroup()}
                      onChange={(e) => handleAllCheckBoxForGroup(e)}
                    />
                  </TableCell>
                  {groupTableHeaderCell.map((headCell: TableHeadCell) => (
                    <TableCell
                      key={headCell.id}
                      sortDirection={
                        orderBy === headCell.sortingProperty ? order : false
                      }
                      align={headCell.position}
                    >
                      {headCell.sorting ? (
                        <TableSortLabel
                          active={orderBy === headCell.sortingProperty}
                          direction={
                            orderBy === headCell.sortingProperty ? order : "asc"
                          }
                          onClick={() =>
                            handleSorting(headCell.sortingProperty)
                          }
                        >
                          {headCell.label}
                          {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                              {orderBy === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {groupDataVisible  && groupDataVisible.length ? (
                  groupDataVisible.map((data: SkillsUserListModel, index) => {
                    const isItemSelected = isSelectedGroup(data?.id);
                    const labelId = `table-checkbox-${index}`;
                    return (
                      <Fragment key={index}>
                        <TableRow
                          role="checkbox"
                          tabIndex={-1}
                          aria-checked={isItemSelected}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox" sx={{ textAlign: 'center', verticalAlign: 'middle' }}>
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              onChange={(event) =>
                                handleGroupSelectCheckbox(event, data?.id)
                              }
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                              sx={{
                                padding: 0,
                                display: 'block',
                                margin: '0 auto',
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {data?.firstName} {data?.lastName}
                          </TableCell>
                          <TableCell>
                            {data?.groups?.length > 0
                              ? renderGroupname(data?.groups)
                              : t("opva.userNotAssignGroup")}
                          </TableCell>
                        </TableRow>
                      </Fragment>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={8}>
                      {t("opva.noAssignedGroups")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <div className="d-flex align-items-center justify-content-end">
              <TablePagination
                className="pagination-container"
                component="div"
                rowsPerPageOptions={[5, 10, 25]}
                count={selectGroupsList?.length}
                page={pageGroup}
                onPageChange={handleGroupChangePage}
                rowsPerPage={perPageRowsGroup}
                onRowsPerPageChange={handleGroupChangeRowsPerPage}
              />
            </div>
          </TableContainer>
        ) : (
          <div className="d-flex align-items-center justify-content-start">
            <Typography variant="bodySmall" className="my-4">
              {t("opva.noUserGRoupMappedToskillMsg")}{" "}
              <Link component="button" onClick={() => navigateSkillAssignment()}>
                {t("opva.here")}
              </Link>
            </Typography>
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          sx={{ textTransform: "none" }}
          onClick={assignWorkflows}
          disabled={
            selected.length === 0 ||
            selectedGroup.length === 0
          }
        >
          {t("opva.assignWorkflows&Upskill")}
        </Button>
      </div>
      <Dialog open={openGroupDialog} onClose={() => setOpenGroupDialog(false)}>
        <DialogContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h5">{t("opva.groupName")}</Typography>
            <IconButton
              aria-label="close"
              onClick={() => setOpenGroupDialog(false)}
              color="primary"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="d-flex flex-column mt-1">
            {groupsList?.length ? (
              groupsList.map((group: SkillsGroupListModel) => (
                <Typography variant="body1" className="mt-2">
                  {group?.name}
                </Typography>
              ))
            ) : (
              <Typography variant="body1" className="mt-2">
                {t("opva.userNotAssignGroup")}
              </Typography>
            )}
          </div>
        </DialogContent>
      </Dialog>
      {row && (
        <MapWorkflowDialog
          isOpen={isOpen}
          closeDialog={closeDialog}
          skillLevelId={levelId}
          skillId={row?.skillId}
          skillName={row?.skillName}
        />
      )}
    </React.Fragment>
  );
};
